<template>
  <d-modal v-if="orderKey !== null" @close="handleClose">
    <d-modal-header>
      <d-modal-title>Transactions</d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <div
        v-if="loading"
        class="d-flex align-items-center justify-content-center py-5 my-5"
      >
        <odd-spinner :size="36" />
      </div>

      <d-list-group
        v-else
        flush
        class="list-group-small mb-3"
        v-for="transaction in transactionHistory"
        :key="transaction.id"
      >
        <d-card>
          <d-card-body class="p-2">
            <div class="d-flex justify-content-between align-items-start">
              <div>
                <h6 class="text-capitalize mb-0">
                  {{ transaction.transaction_type }}
                </h6>
                <div
                  class="text-monospace"
                  style="fontSize: 0.65rem; color: rgba(0,0,0,.5)"
                >
                  Vendor: {{ transaction.processor_unique_id }}
                </div>
                <div
                  class="text-monospace"
                  style="fontSize: 0.65rem; color: rgba(0,0,0,.5)"
                >
                  Oddular: {{ transaction.id }}
                </div>
              </div>
              <div
                class="text-right"
                :title="formatters.datetime.withSubtext(transaction.updated_at)"
                v-html="formatters.datetime.withSubtext(transaction.created_at)"
              ></div>
            </div>
            <div>
              {{ transaction.funding }}
              {{ transaction.brand }}
              <span class="text-monospace">{{ transaction.last4 }}</span>
            </div>
            <div>
              Object Type:
              <span class="ml-2 text-monospace">{{ transaction.object }}</span>
            </div>
            <div>
              Amount Authorized:
              <span class="ml-2 text-monospace">{{
                formatters.currency.usd(transaction.amount_authorized)
              }}</span>
            </div>
            <div>
              Amount Captured:
              <span class="ml-2 text-monospace">{{
                formatters.currency.usd(transaction.amount_captured)
              }}</span>
            </div>
            <div>
              Amount Refunded:
              <span class="ml-2 text-monospace">{{
                formatters.currency.usd(transaction.amount_refunded)
              }}</span>
            </div>

            <d-row>
              <d-col cols="4">Is Captured: <i v-if="transaction.is_captured" class="material-icons ml-2">check</i></d-col>
              <d-col cols="4">Is Refunded: <i v-if="transaction.is_refunded" class="material-icons ml-2">check</i></d-col>
              <d-col cols="4">Is Disputed: <i v-if="transaction.is_disputed" class="material-icons ml-2">check</i></d-col>
            </d-row>
            <!-- <div v-if="!!transaction.meta.charge_meta && !transaction.meta.charge_meta['livemode']" class="text-danger w-100 text-center pt-3 h5">
               ~~~ TEST TRANSACTION ~~~
            </div> -->
          </d-card-body>
        </d-card>
      </d-list-group>
      <div class="w-100 text-center">
        <d-button @click="handleShowApiDataClick" size="sm"
          >Toggle JSON</d-button
        >
      </div>

      <div v-if="showApiData" class="w-100 p-0">
        <pre class="w-100 p-1" style="fontSize: 0.5rem">
              {{ JSON.stringify(transactionHistory, null, 2) }}
              </pre
        >
      </div>
    </d-modal-body>
  </d-modal>
</template>

<script>
import formatters from "@/components/DataGrid/formatters";

export default {
  data() {
    return {
      loading: true,
      transactionHistory: [],
      formatters,
      showApiData: false
    };
  },
  props: {
    orderKey: {
      type: String,
      default: null
    }
  },
  watch: {
    orderKey(newValue) {
      if (newValue !== null) {
        this.loading = true;
        this.$store
          .dispatch("orders/getTransactionHistory", newValue)
          .then(result => {
            this.transactionHistory = result;
            this.loading = false;
          });
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    handleShowApiDataClick() {
      this.showApiData = !this.showApiData;
    }
  }
};
</script>
